export const ClickCategory = Object.freeze({
  CATALOG: 'catalog',
  CART: 'cart',
  FUNNEL: 'funnel',
} as const);
export type ClickCategory = (typeof ClickCategory)[keyof typeof ClickCategory];

export const ClickAction = Object.freeze({
  VIEW_MENU: 'view_menu',
  VIEW_MENU_ITEM: 'view_menu_item',
  ADD_TO_CART: 'add_to_cart',
  START_CHECKOUT: 'start_checkout',
  PLACE_ORDER: 'place_order',
} as const);
export type ClickAction = (typeof ClickAction)[keyof typeof ClickAction];

export interface ViewMenuContext {
  caterer_id: string;
  source?: 'carousel' | 'search_result' | 'direct';
  carousel_id?: string;
  carousel_index?: number;
  search_id?: string | null;
}

export interface ViewMenuItemContext {
  caterer_id: string;
  menu_item_id: string;
  menu_item_name?: string;
}

export interface AddToCartContext {
  caterer_id: string;
  menu_item_id: string;
  quantity?: number;
  size?: string;
  source?: 'quick_add' | 'modal';
}

export interface StartCheckoutContext {
  order_id?: string;
  cart_item_count?: number;
  caterer_id?: string;
}

export interface PlaceOrderContext {
  order_id?: string;
  caterer_id?: string;
}

export type ClickTaxonomyInput =
  | {category: 'catalog'; action: 'view_menu'; context: ViewMenuContext}
  | {category: 'catalog'; action: 'view_menu_item'; context: ViewMenuItemContext}
  | {category: 'cart'; action: 'add_to_cart'; context: AddToCartContext}
  | {category: 'funnel'; action: 'start_checkout'; context: StartCheckoutContext}
  | {category: 'funnel'; action: 'place_order'; context: PlaceOrderContext};

export const VALID_CATEGORY_ACTION_PAIRS = Object.freeze(
  new Set([
    'catalog:view_menu',
    'catalog:view_menu_item',
    'cart:add_to_cart',
    'funnel:start_checkout',
    'funnel:place_order',
  ]),
);

export const CLICK_TAXONOMY_ATTRS = Object.freeze({
  CATEGORY: 'data-click-category',
  ACTION: 'data-click-action',
  CONTEXT: 'data-click-context',
  BOUNDARY: 'data-click-boundary',
} as const);
